<!-- =========================================================================================
  File Name: makeTransfer.vue
  Description: Withdrawal index page
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 2020-10-12
========================================================================================== -->
<template>
<vx-card>
<div id="loadingTab">
    <create-transfer ref="CreateWithdrawal" :selectedItem = "selectedItem" :data="providerMethodList"></create-transfer>
  </div>
</vx-card>
</template>

<script>
import ProviderList from '@/views/components/transaction/ProviderList.vue'
import ProviderGrid from '@/views/components/transaction/ProviderGrid.vue'
import createTransfer from '@/views/components/transaction/createTransfer.vue'
import CreateDepositCrypto from '@/views/components/transaction/CreateDepositCrypto.vue'
import moduleTransactionMng from '@/store/transaction-mng/moduleTransactionMng.js'
import { FormWizard, TabContent, WizardStep } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  components:{
    ProviderList,
    createTransfer,
    ProviderGrid,
    FormWizard,
    TabContent,
    WizardStep,
    CreateDepositCrypto
  },
  data () { 
    return {
      selectedItem: -1,
      providerMethodList: [],
      CryptoInfo: {}
    }
  },
  methods: {

    updateSelectedItem (newValue) {
      this.selectedItem = newValue
      if (this.selectedItem >= 0) this.$refs.formWizard.nextTab()
    },
    ProcessWithdrawal () {
      this.$refs.CreateWithdrawal.startProcess()
    },
  
    
    fetch_provider_data () {     
      this.$store.dispatch('TransactionMng/fetchProviderMethods', this.payload)
        .then(res => { 
          this.$vs.loading.close('#loadingTab > .con-vs-loading')
          this.providerMethodList = res.data.data
        })
        .catch(err => {
          console.error(err) 
        })
    }
  },
  created () {
    if (!moduleTransactionMng.isRegistered) {
      this.$store.registerModule('TransactionMng', moduleTransactionMng)
      moduleTransactionMng.isRegistered = true
    }

    this.fetch_provider_data()
  },
  mounted () {
    this.$vs.loading({
      container: '#loadingTab',
      type: 'sound',
      scale: 1
    })     
  }
}
</script>